module.exports = __webpack_public_path__ + "4409c924fc3223881aeeafa6089f8ebf.pdf";